import React, { useState } from 'react';
import { Star } from 'lucide-react';

import { cn } from 'lib/utils';

interface RatingsProps extends React.HTMLAttributes<HTMLDivElement> {
  rating: number;
  totalStars?: number;
  size?: number;
  fill?: boolean;
  Icon?: React.ReactElement;
  onRatingChange?: (rating: number) => void;
}

export const Rating = ({ rating, onRatingChange, ...props }: RatingsProps) => {
  const [hoverRating, setHoverRating] = useState<number | null>(null);

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    const starIndex = parseInt(
      (event.currentTarget as HTMLDivElement).dataset.starIndex || '0'
    );
    setHoverRating(starIndex);
  };

  const handleMouseLeave = () => {
    setHoverRating(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const starIndex = parseInt(
      (event.currentTarget as HTMLDivElement).dataset.starIndex || '0'
    );
    setHoverRating(null);
    onRatingChange?.(starIndex);
  };

  const displayRating = hoverRating ?? rating;
  const fullStars = Math.floor(displayRating);

  return (
    <div
      className={cn('flex w-fit items-center gap-2 ')}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      <div className='flex items-center' onMouseEnter={handleMouseEnter}>
        {[...Array(fullStars)].map((_, i) =>
          React.cloneElement(<Star />, {
            key: i,
            size: 20,
            className: cn('fill-current stroke-1', 'text-primary'),
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            'data-star-index': i + 1,
          })
        )}

        {[...Array(Math.max(0, 5 - fullStars))].map((_, i) =>
          React.cloneElement(<Star />, {
            key: i + fullStars + 1,
            size: 20,
            className: cn('stroke-1', 'text-muted-foreground'),
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            'data-star-index': i + fullStars + 1,
          })
        )}
      </div>
    </div>
  );
};
